import React, { FC, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import IconButton from '@material-ui/core/IconButton';
import CloudUpload from '@material-ui/icons/CloudUpload';
import { saveDocument, getDocumentLoaders } from 'features/Documents/documents';
import { useTranslation } from 'react-i18next';

const UploadDocument: FC<{ /* id: string; */ showDropArea?: boolean /* type: string */ }> = ({
  /*  id, */ showDropArea /* , type */
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const fileInputDivRef = useRef<HTMLInputElement | null>(null);
  const formRef = useRef<HTMLFormElement | null>(null);
  const dispatch = useDispatch();
  const { isLoading } = useSelector(getDocumentLoaders);
  const { t } = useTranslation();

  return (
    <>
      <label htmlFor="contained-button-file">
        {!showDropArea && (
          <IconButton aria-label="upload-document" color="primary" component="span" disabled={isLoading}>
            <CloudUpload />
          </IconButton>
        )}
        {showDropArea && (
          <div
            style={{
              border: 'dashed 1px black',
              cursor: 'pointer',
              display: 'flex',
              height: '100px',
              justifyContent: 'center',
              alignItems: 'center'
            }}
            onDragOver={ev => {
              ev.preventDefault();
            }}
            onDrop={e => {
              const file = get(e, 'dataTransfer.files[0]'); // Array of all files
              dispatch(saveDocument(file));
              formRef.current?.reset();
              e.preventDefault();
            }}
            ref={fileInputDivRef}
          >
            <span>{t('documents.upload document hint')}</span>
          </div>
        )}
        <input
          accept="image/*, .pdf,.doc,.docx"
          id="contained-button-file"
          style={{ display: 'none' }}
          type="file"
          ref={fileInputRef}
          onChange={async () => {
            const file = get(fileInputRef, 'current.files[0]');
            dispatch(saveDocument(file));
            formRef.current?.reset();
          }}
        />
      </label>
    </>
  );
};

export { UploadDocument };
